import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar, NavbarBrand, NavbarToggler, Collapse, Nav, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, NavbarText } from 'reactstrap';
import { categories } from '../Data/data.js';
import { BsFillTelephoneOutboundFill } from "react-icons/bs";

const Header = () => {
    let navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    return (
        <Navbar className='d-flex align-items-center px-5 py-3' expand="lg" style={{ backgroundColor: '#124167' }}>
            <NavbarBrand className='px-3 pt-3' onClick={() => navigate('/')} style={{ cursor: 'pointer', color: 'whitesmoke' }}><h5>AL-NAYAZAK</h5></NavbarBrand>
            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
                <Nav className="me-auto px-4" navbar>
                    <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle nav caret style={{ color: 'whitesmoke' }}>Categories</DropdownToggle>
                        <DropdownMenu end>
                            {categories.map((category, index) => (
                                <DropdownItem onClick={() => navigate(`detail/${category.slug}`)}>{category.heading}</DropdownItem>
                            ))}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Nav>
            <NavbarText style={{ color: 'whitesmoke' }}><BsFillTelephoneOutboundFill /> Call Now +971501790123</NavbarText>
            </Collapse>
        </Navbar>
    );
};

export default Header;